import { gql } from "@apollo/client";

export const createVoucher = gql`
  mutation createSalesBill($createInput: VoucherEntriesInput!, $Transactions: [TransactionInput!]) {
    createSalesBill(createInput: $createInput, Transactions: $Transactions) {
      _id
    }
  }
`;

export const createLMSVoucher = gql`
  mutation CreateLMSSalesBill($createInput: LMSSalesBillInput!, $Transactions: [TransactionInput!]) {
    createLMSSalesBill(createInput: $createInput, Transactions: $Transactions) {
      _id
    }
  }
`;

export const createLMSVoucherReturn = gql`
  mutation createLMSSalesReturnBill($createInput: LMSSalesBillInput!, $Transactions: [TransactionInput!]) {
    createLMSSalesReturnBill(createInput: $createInput, Transactions: $Transactions) {
      _id
    }
  }
`;

export const editVoucher = gql`
  mutation editSalesBill($id: ID!, $userInput: VoucherEntriesInput!, $Transactions: [TransactionInput!]) {
    editSalesBill(id: $id, userInput: $userInput, Transactions: $Transactions) {
      _id
    }
  }
`;

export const LMSBilleditVoucher = gql`
  mutation EditLMSSalesBill($id: ID!, $userInput: LMSSalesBillInput!, $Transactions: [TransactionInput!]) {
    editLMSSalesBill(id: $id, userInput: $userInput, Transactions: $Transactions) {
      _id
    }
  }
`;

export const SalesReturneditVoucher = gql`
  mutation EditLMSSalesReturnBill($id: ID!, $userInput: LMSSalesBillInput!, $Transactions: [TransactionInput!]) {
    editLMSSalesReturnBill(id: $id, userInput: $userInput, Transactions: $Transactions) {
      _id
    }
  }
`;

export const SalesReturnDeleteVoucher = gql`
  mutation DeleteLMSSalesReturn($idsToDelete: [ID]) {
    deleteLMSSalesReturn(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

// export const AccountDetails = ``

export const getsalesBillById = gql`
  query GetSalesBillById($getSalesBillByIdId: ID) {
    GetSalesBillById(id: $getSalesBillByIdId) {
      Sales_Account {
        _id
        Search_Value
        Account_Name
      }
      Doc_Date
      Invoice_No
      Against_Invoice_No
      Tax_Group {
        Tax_Type

        Tax_Group_Name
        Search_Value
        _id
        Tax_Rate {
          Tax_Percentage
        }
        Selected_Taxes {
          Input_Account {
            Account_Name
            _id

            Search_Value
          }
          Output_Account {
            Account_Name
            _id

            Search_Value
          }
          Tax_Type
          Search_Value
          Tax_Name
          _id
          Tax_Rate {
            Tax_Percentage
          }
        }
      }
      Party {
        _id
        Search_Value
        AccountData {
          _id
          Business_Pincode
          Business_State
          Residential_Pincode
          Residential_State
          Balance_Method
          GST_Number
        }
      }
      Tax
      Ref_No
      Unique_Ref_No
      Narration
      Acknowledgement_Doc
      Invoice_Doc
      E_way_bill_Doc
      File
      Doc
      _id
      Tax
      Date
      CashOrDebit
      Voucher_Series_Data {
        Prefix
        Sufix
        Search_Value
        Value
        _id
      }

      Bill_No
      RCM

      Voucher_Mode

      TransactionsData {
        TDS_TCS_Master {
          _id
          Tax_Name
          Section
          Search_Value
          Tax_Percentage
          Receivable_Account {
            _id
          }
          Payable_Account {
            _id
          }
        }
        Transaction_Type
        Tax_Type
        Amount
        Account {
          _id
          Account_Name
          Search_Value
        }
        Account_ID {
          _id
        }
        Tax_Amount
        Rate
        HSN_Code {
          _id
          Search_Value

          Code
        }
        Tax_Group {
          _id
          Search_Value
          Tax_Group_Name
          Selected_Taxes {
            Input_Account {
              Account_Name
              _id

              Search_Value
            }
            Output_Account {
              Account_Name
              _id

              Search_Value
            }
            Tax_Name
            Tax_Type
            Tax_Rate {
              _id
              Tax_Percentage
            }
            _id
          }
        }
        Stock_Item {
          _id
          Stock_Value
          Stock_Group
          Search_Value
          Rate
          Item_Name
          Current_Qty
        }
        Particular
        Quantity
        Item_Value
        Entry_For
        Tax_Rate
        Name
      }
      Transactions {
        _id
        Transaction_Type
        Serial_No
        Entry_Type
        Amount
        Account_ID
        Account {
          _id
          Search_Value
          Name
        }
      }
      Sales_Account_Selection
      Default_Voucher_Series {
        _id
        Sufix
        Prefix
        Search_Value
      }
      customFieldData
    }
  }
`;

export const getLMSsalesBillById = gql`
  query GetLMSSalesBillById($id: ID) {
    GetLMSSalesBillById(id: $id) {
      _id
      RCM
      salesBillID
      Sales_Invoice_No
      Sales_Invoice_Date
      Entry_Type
      Voucher_Type
      Voucher_Mode
      Voucher_Series_Data {
        _id
        Unique_Id
        Type_of_voucher
        Prefix
        Starting_No
        Sufix
        Financial_year
        Is_Active
        Search_Value
      }
      Default_HSNCode {
        _id
        Unique_Id
        Search_Value
      }
      Default_Party {
        _id
        Unique_Id
        Search_Value
      }
      Default_TaxGroup {
        _id
        Unique_Id
        Search_Value
      }
      Default_SalesAccount {
        _id
        Unique_Id
        Search_Value
      }
      Default_CashOrDebit
      Default_LoadType
      Default_RCM
      Default_Voucher_Series {
        _id
        Sufix
        Prefix
        Search_Value
      }
      Buyer_Name_Data {
        Name
        _id
        Search_Value
        Refered_To_ID
      }
      Sales_Account {
        _id
        Search_Value
        Account_Name
      }
      Tax_Group {
        Tax_Type
        Tax_Group_Name
        Search_Value
        _id
        Tax_Rate {
          Tax_Percentage
        }
        Selected_Taxes {
          Tax_Type
          Search_Value
          Tax_Name
          _id
          Tax_Rate {
            Tax_Percentage
          }
          Input_Account {
            Account_Name
            _id

            Search_Value
          }
          Output_Account {
            Account_Name
            _id

            Search_Value
          }
        }
      }
      Load_Type
      Tax
      Date
      Bill_No
      CashOrDebit
      HSN_Code {
        _id
        Unique_Id
        Code
        Search_Value
        Description
        FCM_Percentage
        FCM_For_Unregister_Percentage
        RCM_Percentage
        FCM {
          _id
          Unique_Id
          Tax_Percentage
          Search_Value
          createdAt
          updatedAt
        }
        FCM_For_Unregister {
          _id
          Unique_Id
          Tax_Percentage
          Search_Value
          createdAt
          updatedAt
        }
        RCM {
          _id
          Unique_Id
          Tax_Percentage
          Search_Value
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      Party {
        _id
        Search_Value
        AccountData {
          _id
          Business_Pincode
          Business_State
          Residential_Pincode
          Residential_State
          Balance_Method
          GST_Number
        }
      }

      Invoice_No
      customFieldData
      Transactions {
        _id
        Transaction_Type
        Serial_No
        Entry_Type
        Amount
        Account_ID
        Account {
          _id
          Search_Value
        }
      }
      TransactionsData {
        Transaction_Type
        Tax_Type
        Amount
        Account {
          _id
          Account_Name
          Search_Value
        }
        Account_ID {
          _id
        }
        Tax_Amount
        Rate
        HSN_Code {
          _id
          Search_Value

          Code
        }
        Tax_Group {
          _id
          Search_Value
          Tax_Group_Name
          Selected_Taxes {
            Tax_Name
            Tax_Type
            Tax_Rate {
              _id
              Tax_Percentage
            }
            _id
          }
        }
        Stock_Item {
          _id
          Stock_Value
          Stock_Group
          Search_Value
          Rate
          Item_Name
          Current_Qty
        }
        Particular
        Quantity
        Item_Value
        Entry_For
        Tax_Rate
        Name
      }
      Bill_BookingBroker_Data {
        _id
        Date
        Freight_Type
        Material_Description
        Material_Invoice_No
        Value
        Eway_Bill_Number
        Vehicle_Type
        Driver_Name
        Bill_Party_Sub_Total
      }
      FTL_Consignment_Note_Data {
        _id
        FTL_CN_Id
        LR_No
        Unique_Id
        Consignor_City
        Consignee_City
        Consignor
        Consignee
        Bill_Consignor
        Total_Number_Of_Boxes
        Total_Actual_Weight
        Total_Volumetric_Weight
        Total_Weight
        Total_KM
        Rate
        Freight_On
        Freight_Amount
        Docket_Amount
        Pickup_Charges
        Delivery_Charges
        FOV
        FSC
        Other_Charges
        Holding_Charge
        Hamali_Charge
        Total
      }
      PTL_Consignment_Note_Data {
        _id
        Date
        LR_No
        Unique_Id
        Consignor_City
        Consignee_City
        Consignor
        Consignee
        Bill_Consignor
        Total_Number_Of_Boxes
        Total_Actual_Weight
        Total_Volumetric_Weight
        Total_Weight
        Total_KM
        Rate
        Freight_On
        Freight_Amount
        Docket_Amount
        Pickup_Charges
        Delivery_Charges
        FOV
        FSC
        Other_Charges
        Holding_Charge
        Hamali_Charge
        Total
        PTL_CN_Id
      }
      Consignment_Note_Ids
      Narration
      FTL_Consignment_Note_Data {
        _id
      }
      PTL_Consignment_Note_Data {
        Request
        _id
      }
    }
  }
`;
export const DeleteSalesBill = gql`
  mutation deleteSalesBill($idsToDelete: [ID]) {
    deleteSalesBill(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const DeleteLMSSalesBill = gql`
  mutation DeleteLMSSalesBill($idsToDelete: [ID]) {
    deleteLMSSalesBill(idsToDelete: $idsToDelete) {
      message
    }
  }
`;
